import { render, staticRenderFns } from "./PartnersEditPartner.vue?vue&type=template&id=acc81cc8&"
import script from "./PartnersEditPartner.vue?vue&type=script&lang=js&"
export * from "./PartnersEditPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports